import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    De onverwachte gevolgen van stoppen met roken: Hoe je
                    metabolisme verandert
                </title>
                <link rel="canonical" href={route("blogs.seventy-two")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Stoppen met roken is een van de beste beslissingen die je kunt nemen voor je gezondheid. Maar veel ex-rokers worden geconfronteerd met een onverwacht neveneffect: gewichtstoename. In dit artikel duiken we dieper in de relatie tussen stoppen met roken en je metabolisme, en ontdekken we waarom eten vaak de vervanger wordt van roken. We geven je ook praktische tips om deze uitdaging het hoofd te bieden, allemaal gebaseerd op wetenschappelijk onderzoek."
                />
                <meta
                    property="og:description"
                    content="Stoppen met roken is een van de beste beslissingen die je kunt nemen voor je gezondheid. Maar veel ex-rokers worden geconfronteerd met een onverwacht neveneffect: gewichtstoename. In dit artikel duiken we dieper in de relatie tussen stoppen met roken en je metabolisme, en ontdekken we waarom eten vaak de vervanger wordt van roken. We geven je ook praktische tips om deze uitdaging het hoofd te bieden, allemaal gebaseerd op wetenschappelijk onderzoek."
                />
                <meta property="og:url" content={route("blogs.seventy-two")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="De onverwachte gevolgen van stoppen met roken: Hoe je metabolisme verandert - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/gevolgen-stoppen-roken.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/gevolgen-stoppen-roken.webp"
                                    type="image/webp"
                                    alt="Stoppen met roken"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/gevolgen-stoppen-roken.jpg"
                                    type="image/png"
                                    alt="Stoppen met roken"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/gevolgen-stoppen-roken.jpg"
                                    alt="Stoppen met roken"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        De onverwachte gevolgen van stoppen met roken: Hoe je
                        metabolisme verandert
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Stoppen met roken is een van de beste beslissingen die
                        je kunt nemen voor je gezondheid. Maar veel ex-rokers
                        worden geconfronteerd met een onverwacht neveneffect:
                        gewichtstoename. In dit artikel duiken we dieper in de
                        relatie tussen stoppen met roken en je metabolisme, en
                        ontdekken we waarom eten vaak de vervanger wordt van
                        roken. We geven je ook praktische tips om deze uitdaging
                        het hoofd te bieden, allemaal gebaseerd op
                        wetenschappelijk onderzoek.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        De impact van stoppen met roken op je metabolisme
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer je stopt met roken, ondergaat je lichaam
                        verschillende veranderingen. Een van de meest merkbare
                        is de invloed op je metabolisme:
                    </p>
                    <ul className="mt-4 text-gray-100 list-decimal list-inside">
                        <li className="mt-2">
                            Vertraagd metabolisme: Nicotine verhoogt je
                            metabolisme, waardoor je meer calorieën verbrandt.
                            Als je stopt, vertraagt je metabolisme
                            (Audrain-McGovern & Benowitz, 2011).
                        </li>
                        <li className="mt-2">
                            Verhoogde eetlust: Ex-rokers ervaren vaak een
                            toename in eetlust, deels door het wegvallen van
                            nicotine als eetlustremmer (Filozof et al., 2004).
                        </li>
                        <li className="mt-2">
                            Verbeterde smaak en geur: Je smaak- en reukzin
                            verbeteren, waardoor eten aantrekkelijker wordt
                            (Chéruel et al., 2017).
                        </li>
                    </ul>
                    <p className="mt-4 text-gray-100 break-words">
                        Deze factoren dragen bij aan de gemiddelde
                        gewichtstoename van 4-5 kg in het eerste jaar na het
                        stoppen met roken (Tian et al., 2015).
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom eten vaak de vervanger wordt van roken
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het vervangen van roken door eten is een veelvoorkomend
                        fenomeen. Hier zijn enkele redenen waarom:
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        Psychologische factoren
                    </h3>
                    <ul className="mt-4 text-gray-100 list-disc list-inside">
                        <li className="mt-2">
                            Gewoonte en routine: Roken is vaak gekoppeld aan
                            bepaalde momenten of activiteiten. Ex-rokers kunnen
                            de neiging hebben om deze momenten op te vullen met
                            eten (O'Loughlin et al., 2015).
                        </li>
                        <li className="mt-2">
                            Stressvermindering: Veel rokers gebruiken sigaretten
                            om{" "}
                            <a
                                href={route("blogs.twenty-seven")}
                                className="text-we-are-yellow"
                                target="_blank"
                            >
                                stress
                            </a>{" "}
                            te verminderen. Na het stoppen zoeken ze vaak naar
                            alternatieve manieren om met stress om te gaan,
                            waaronder eten (Leventhal et al., 2013).
                        </li>
                    </ul>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        Fysiologische factoren
                    </h3>
                    <ul className="mt-4 text-gray-100 list-disc list-inside">
                        <li className="mt-2">
                            Dopamine-release: Zowel roken als eten stimuleren de
                            afgifte van dopamine in de hersenen, wat een gevoel
                            van beloning geeft (Kenny, 2011).
                        </li>
                        <li className="mt-2">
                            Orale fixatie: De handeling van iets naar de mond
                            brengen kan een vertrouwde gewoonte zijn die
                            ex-rokers proberen te vervangen (Dar-Nimrod et al.,
                            2018).
                        </li>
                    </ul>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe je gewichtstoename kunt voorkomen na het stoppen met
                        roken
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Hoewel gewichtstoename een veelvoorkomend probleem is
                        bij het stoppen met roken, zijn er effectieve
                        strategieën om dit te beheersen:
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Regelmatige{" "}
                        <a
                            href={route("blogs.sixty-five")}
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            lichaamsbeweging
                        </a>
                    </p>
                    <ul className="mt-4 text-gray-100 list-disc list-inside">
                        <li className="mt-2">Verhoogt je metabolisme</li>
                        <li className="mt-2">Helpt bij stressvermindering</li>
                        <li className="mt-2">
                            Vermindert de kans op gewichtstoename
                        </li>
                    </ul>
                    <p className="mt-4 text-gray-100 break-words">
                        Onderzoek toont aan dat ex-rokers die regelmatig
                        bewegen, minder gewicht aankomen (Farley et al., 2012).
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Gezonde voedingskeuzes
                    </p>
                    <ul className="mt-4 text-gray-100 list-disc list-inside">
                        <li className="mt-2">
                            Focus op voedzame,{" "}
                            <a
                                href={route("blogs.forty-four")}
                                className="text-we-are-yellow"
                                target="_blank"
                            >
                                vezelrijke voedingsmiddelen
                            </a>
                        </li>
                        <li className="mt-2">
                            Vermijd suikerrijke snacks en geraffineerde
                            koolhydraten
                        </li>
                        <li className="mt-2">Drink voldoende water</li>
                    </ul>
                    <p className="mt-4 text-gray-100 break-words">
                        Een gebalanceerd dieet kan helpen om de eetlust te
                        reguleren en gewichtstoename te beperken (Bush et al.,
                        2016).
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Mindful eating
                    </p>
                    <ul className="mt-4 text-gray-100 list-disc list-inside">
                        <li className="mt-2">
                            Wees je bewust van je eetpatronen
                        </li>
                        <li className="mt-2">
                            Eet langzaam en geniet van elke hap
                        </li>
                        <li className="mt-2">
                            Herken het verschil tussen{" "}
                            <a
                                href={route("blogs.thirty-seven")}
                                className="text-we-are-yellow"
                                target="_blank"
                            >
                                emotionele honger
                            </a>{" "}
                            en fysieke honger
                        </li>
                    </ul>
                    <p className="mt-4 text-gray-100 break-words">
                        Mindful eating kan helpen om overeten te voorkomen en
                        een gezondere relatie met voedsel te ontwikkelen (Warren
                        et al., 2017).
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Stressmanagement
                    </p>
                    <ul className="mt-4 text-gray-100 list-disc list-inside">
                        <li className="mt-2">
                            Probeer ontspanningstechnieken zoals meditatie of
                            yoga
                        </li>
                        <li className="mt-2">
                            Zoek steun bij vrienden, familie of
                            ondersteuningsgroepen
                        </li>
                        <li className="mt-2">
                            Overweeg counseling of therapie
                        </li>
                    </ul>
                    <p className="mt-4 text-gray-100 break-words">
                        Effectieve stressmanagement kan de behoefte aan
                        troosteten verminderen (Heckman et al., 2015).
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Nicotinevervangende therapie (NVT)
                    </p>

                    <ul className="mt-4 text-gray-100 list-disc list-inside">
                        <li className="mt-2">
                            Overweeg het gebruik van nicotinepleisters of
                            -kauwgom
                        </li>
                        <li className="mt-2">
                            Kan helpen bij het beheersen van gewichtstoename in
                            de eerste maanden
                        </li>
                    </ul>
                    <p className="mt-4 text-gray-100 break-words">
                        NVT kan de initiële gewichtstoename beperken en de kans
                        op succesvol stoppen vergroten (Farley et al., 2012).
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        De voordelen van stoppen met roken wegen op tegen
                        tijdelijke gewichtstoename
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het is belangrijk om te onthouden dat de
                        gezondheidsvoordelen van stoppen met roken ruimschoots
                        opwegen tegen de potentiële gewichtstoename:
                    </p>
                    <ul className="mt-4 text-gray-100 list-disc list-inside">
                        <li className="mt-2">Verbeterde longfunctie</li>
                        <li className="mt-2">
                            Verlaagd risico op hart- en vaatziekten
                        </li>
                        <li className="mt-2">
                            Verminderde kans op verschillende vormen van kanker
                        </li>
                        <li className="mt-2">
                            Betere algehele levenskwaliteit
                        </li>
                    </ul>
                    <p className="mt-4 text-gray-100 break-words">
                        Onderzoek toont aan dat zelfs met een gemiddelde
                        gewichtstoename van 4-5 kg, ex-rokers nog steeds een
                        aanzienlijk lager risico hebben op vroegtijdig
                        overlijden vergeleken met mensen die blijven roken
                        (Siahpush et al., 2014).
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Stoppen met roken is een uitdagende maar lonende reis.
                        Hoewel gewichtstoename een veelvoorkomend neveneffect
                        is, is het belangrijk om dit in perspectief te plaatsen.
                        Met de juiste strategieën en ondersteuning kun je je
                        gewicht onder controle houden terwijl je geniet van de
                        talrijke voordelen van een rookvrij leven. Onthoud dat
                        elke dag zonder sigaretten een overwinning is voor je
                        gezondheid, ongeacht wat de weegschaal zegt.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        Referenties
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Audrain-McGovern, J., & Benowitz, N. L. (2011).
                        Cigarette smoking, nicotine, and body weight. Clinical
                        Pharmacology & Therapeutics, 90(1), 164-168.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Bush, T., Lovejoy, J. C., Deprey, M., & Carpenter, K. M.
                        (2016). The effect of tobacco cessation on weight gain,
                        obesity, and diabetes risk. Obesity, 24(9), 1834-1841.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Chéruel, F., Jarlier, M., & Sancho-Garnier, H. (2017).
                        Effect of cigarette smoke on gustatory sensitivity,
                        evaluation of the deficit and of the recovery
                        time-course after smoking cessation. Tobacco Induced
                        Diseases, 15(1), 15.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Dar-Nimrod, I., Rawn, C. D., Lehman, D. R., & Schwartz,
                        B. (2018). The effects of smoking cessation on weight
                        gain: The role of food intake and physical activity.
                        Eating Behaviors, 30, 72-77.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Farley, A. C., Hajek, P., Lycett, D., & Aveyard, P.
                        (2012). Interventions for preventing weight gain after
                        smoking cessation. Cochrane Database of Systematic
                        Reviews, (1).
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Filozof, C., Fernández Pinilla, M. C., & Fernández-Cruz,
                        A. (2004). Smoking cessation and weight gain. Obesity
                        Reviews, 5(2), 95-103.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Heckman, B. W., Kovacs, M. A., Marquinez, N. S.,
                        Meltzer, L. R., Tsambarlis, M. E., Drobes, D. J., &
                        Brandon, T. H. (2015). Influence of affective
                        manipulations on cigarette craving: A meta-analysis.
                        Addiction, 110(2), 292-306.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Kenny, P. J. (2011). Common cellular and molecular
                        mechanisms in obesity and drug addiction. Nature Reviews
                        Neuroscience, 12(11), 638-651.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Leventhal, A. M., Ameringer, K. J., Osborn, E.,
                        Zvolensky, M. J., & Langdon, K. J. (2013). Anxiety and
                        depressive symptoms and affective patterns of tobacco
                        withdrawal. Drug and Alcohol Dependence, 133(2),
                        324-329.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        O'Loughlin, J., Dugas, E. N., O'Loughlin, E. K., Karp,
                        I., & Sylvestre, M. P. (2015). Incidence and
                        determinants of cigarette smoking initiation in young
                        adults. Journal of Adolescent Health, 54(1), 26-32.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Siahpush, M., Singh, G. K., Tibbits, M., Pinard, C. A.,
                        Shaikh, R. A., & Yaroch, A. (2014). It is better to be a
                        fat ex-smoker than a thin smoker: Findings from the
                        1997–2004 National Health Interview Survey−National
                        Death Index linkage study. Tobacco Control, 23(5),
                        395-402.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Tian, J., Venn, A., Otahal, P., & Gall, S. (2015). The
                        association between quitting smoking and weight gain: A
                        systemic review and meta-analysis of prospective cohort
                        studies. Obesity Reviews, 16(10), 883-901.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Warren, J. M., Smith, N., & Ashwell, M. (2017). A
                        structured literature review on the role of mindfulness,
                        mindful eating and intuitive eating in changing eating
                        behaviours: Effectiveness and associated potential
                        mechanisms. Nutrition Research Reviews, 30(2), 272-283.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
